/*
 * @Author: your name
 * @Date: 2021-07-13 21:00:42
 * @LastEditTime: 2022-11-07 16:27:44
 * @LastEditors: 谢树和 shuhe.xie@southgis.com
 * @Description: In User Settings Edit
 * @FilePath: \maine:\git\xadc\src\store\index.js
 */
import Vue from 'vue'
import Vuex from 'vuex'
import form from './modules/form'
import opinion from './modules/opinion'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: '',
    userInfo: '' || JSON.parse(localStorage.getItem('userInfo')),
    userFullInfo:"" || JSON.parse(localStorage.getItem('userFullInfo')),
    includes: [],
    footerContent: '',
    projectCode: {},
    loginInfo: '' || JSON.parse(localStorage.getItem('loginInfo')),
    loginConfig: {}
  },
  getters: {
    getUserInfo(state) {
      return state.userInfo
    },
    getLoginInfo(state) {
      return state.loginInfo
    }
  },
  mutations: {
    setUserInfo(state, data) {
      // 把登录的用户的名保存到localStorage中，防止页面刷新，导致vuex重新启动，用户名就成为初始值（初始值为空）的情况
      localStorage.setItem('userInfo', JSON.stringify(data))
      if (!data) return
      state.userInfo = data
    },
    setFullUserInfo(state, data) {
      // 把登录的用户的名保存到localStorage中，防止页面刷新，导致vuex重新启动，用户名就成为初始值（初始值为空）的情况
      localStorage.setItem('userFullInfo', JSON.stringify(data))
      if (!data) return
      state.userFullInfo = data
    },
    setLoginInfo(state, data) {
      localStorage.setItem('loginInfo', JSON.stringify(data))
      if (!data) return
      state.loginInfo = data
    },
    cleanUserInfo(state) {
      localStorage.removeItem('userInfo')
      state.userInfo = ''
    },
    cleanFullUserInfo(state) {
      localStorage.removeItem('userFullInfo')
      state.userInfo = ''
    },
    cleanLoginInfo(state) {
      localStorage.removeItem('loginInfo')
      state.loginInfo = ''
    },
    updateIncludes(state, data) {
      state.includes = data
    },
    setProjectCode(state, data) {
      data.forEach(element => {
        const key = element.code
        const value = element.showValue
        state.projectCode[key] = value
      })
    }
  },
  actions: {},
  modules: {
    form,
    opinion
  }
})
